import { select, takeLatest } from 'redux-saga/effects';
import { EmailLogActions } from '../constants';
import { EmailsLogApi } from 'src/services/end-points';
import { StoreState } from '../reducers';
import { PaginationService } from '../../services/api-handlers/pagination';
import { GetEmailsLogsAction, ResendEmailLogAction } from '../actions/emails-log-actions';
import sortingService from '../../services/sorting';
import { handleError, resolveApiCall, ResolverApiFailure } from '../../services/api-handlers/api-resolver';

function* handleFetchEmailsLog(action: GetEmailsLogsAction) {
    const oldData = yield select((state: StoreState) => state.emailsLog.data);
    const { filters, sorting, page, itemsPerPage } = action.payload;

    yield PaginationService.setPageSize(itemsPerPage).resolveApiCall(action, page, oldData, () =>
        EmailsLogApi.getEmailsLog({
            ...filters,
            order: sortingService.makeOrder(sorting),
            page,
            itemsPerPage,
            pagination: itemsPerPage === -1 ? 0 : 1,
        }),
    );
}

function* handleResendEmailLog(action: ResendEmailLogAction) {
    const {
        payload: { id, onSuccess, onError },
    } = action;

    yield resolveApiCall(
        action,
        () => EmailsLogApi.resendEmailLog(id),
        function (data) {
            if (onSuccess) {
                onSuccess();
            }
        },
        function (result: ResolverApiFailure) {
            if (result.error && result.error.response && result.error.response.status) {
                if (onError) {
                    onError(result.error.response.data.detail ?? result.error.message ?? 'Unknown error');
                }
            }
            handleError(result);
        },
    );
}

export default function* () {
    yield takeLatest(EmailLogActions.FETCH_EMAILS_LOG, handleFetchEmailsLog);
    yield takeLatest(EmailLogActions.EMAIL_LOG_RESEND, handleResendEmailLog);
}
